import React, { useState } from "react";
import { TableRow, Table, TableHead, TableBody, TableCell, TableContainer, Paper } from "@material-ui/core";

import AttendenceService from "./Locality/Service/attendenceService";
import AddClassService from "./Locality/Service/addClassService";
import { Grid, Box } from "@material-ui/core";
import { useEffect } from 'react';
import StudentService from "./Locality/Service/studentService";
import TablePagination from '@material-ui/core/TablePagination';
import Widget from "../../components/Widget/Widget";
import PageTitle from "../../components/PageTitle/PageTitle";
import { withStyles, makeStyles } from '@material-ui/core/styles';
const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#0f3b62ad",
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);
const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
}));
export default function Reports() {

    const tableHeaders = ['Class', 'Total', 'Present Count', 'Absent Count'];
    const classes = useStyles();
    const [result, setResult] = useState([]);
    const [reportList, setReportList] = useState([]);
    const [pg, setpg] = React.useState(0);
    const [rpg, setrpg] = React.useState(1000);
    const [startDate1, setStartDate1] = useState('');
    const [endDate1, setEndDate1] = useState('');
    const [age, setAge] = React.useState('');
    var [studentId, setStudentId] = useState("");
    const [classValue, setClassValue] = useState("");

    var [classId, setClassId] = useState("");
    const [absentStudentList, setAbsentStudentList] = useState([]);

    const [studentList, setStudentList] = useState([]);
    const [getReport, setGetReport] = useState([]);
    const [currentAttendanceSummary, setCurrentAttendanceSummary] = useState([]);
    const [addClassList, setAddClassList] = useState([]);
    const current = new Date();
    const date = `${current.getFullYear()}-0${current.getMonth() + 1}-${current.getDate()}`;
    const [showAbsentListClassId, setShowAbsentListClassId] = useState(null);


    useEffect(() => {
        getCurrentDayCount();
        getAddClassList();
        return () => {
            setReportList([]);
            setStudentList([]);
            setGetReport([]);
        }
    }, []);
    const handleChangeRowsPerPage = (event) => {
        setrpg(parseInt(event.target.value, 10));
        setpg(0);
    }
    const getAddClassList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        AddClassService.getAllAddClass(userDetails.schooleId).then((res) => {
            if (userDetails.role === "TEACHER") {
                res = res.filter(res => res._id === userDetails.classId);
            }
            setAddClassList(res);
            if (res.length > 0) {
                const classId = res[0]._id;
                setClassId(res[0]._id)
                getStudentList({ target: { value: res[0]._id } });
                getCurrentDayCount(res);

            }

        }).catch((err) => {
            // setError(err.message);
        });
    }


    const getStudentList = (event, obj) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        // const getStuList = {  classId:event.target.value}; 

        setClassId((event && event.target) ? event.target.value : '')
        StudentService.getAllStudentById(userDetails.schooleId, { classId: (event && event.target) ? event.target.value : '' }
        ).then((res) => {

            const studentDetails = res.map(res => {
                return { _id: res._id, studentName: `${res.firstName} ${res.lastName}`, status: true };
            });

            setStudentList(studentDetails);


        }).catch((err) => {
            // setError(err.message);
        });
    }

    const getCurrentDayCount = (studentList = []) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const currentDate = new Date().toISOString().split("T")[0];

        const keys = {
            "schooleId": userDetails.schooleId,
            startDate: currentDate,
            endDate: currentDate

        }


        AttendenceService.getCurrentDayCount(keys).then((res) => {


            setCurrentAttendanceSummary(res);
            const absentIds = (res.attendenceReport || [])
                .filter(s => s.status === false)
                .map(s => s.studentId);
            const updatedStudentList = studentList.map(student => ({
                ...student,
                status: !absentIds.includes(student._id)
            }));

            setStudentList(updatedStudentList);

        }).catch((err) => {
            console.error(err);
        });
    }

    const handleChangePage = (event, newpage) => {
        setpg(newpage);
    }
    const handleAbsentClick = (classId) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const keys = {
            schooleId: userDetails.schooleId,
            classId,
            date: new Date().toISOString().split("T")[0],
        };

        AttendenceService.getAbsentStudents(keys).then((res) => {

            setAbsentStudentList(res);
            debugger
            setShowAbsentListClassId(classId);
        }).catch((err) => {
            console.error("Failed to fetch absent students:", err);
        });
    };

    return (

        <>
            <PageTitle title="Day  Reports" />

            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <Widget upperTitle noBodyPadding bodyClass={classes.tableOverflow}>
                                                                        <TableContainer component={Paper} style={{ maxHeight: 500 }}>
                        
                        <Table stickyHeader className="mb-0 dashboard-table-row-hover">
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell style={{  textAlign:'center'}}>Class</StyledTableCell>
                                    <StyledTableCell style={{  textAlign:'center'}}>Total</StyledTableCell>
                                    <StyledTableCell style={{  textAlign:'center'}}>Present Count</StyledTableCell>
                                    <StyledTableCell style={{  textAlign:'center'}}>Absent Count</StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {currentAttendanceSummary.map((currentAttendanceSummary) => {
                                    const isPastDue = new Date() > new Date(currentAttendanceSummary.dueDate);
                                    return (
                                        <TableRow key={currentAttendanceSummary._id}>
                                            <TableCell style={{ fontSize:'18px', textAlign:'center'}}>{currentAttendanceSummary.className}</TableCell>
                                            <TableCell  style={{ fontSize:'20px', textAlign:'center'}}>{currentAttendanceSummary.totalStudents}</TableCell>
                                            <TableCell style={{color:'green', fontSize:'20px', textAlign:'center'}}>{currentAttendanceSummary.presentStudents}</TableCell>
                                            <TableCell style={{ cursor: "pointer", color: "red",fontSize:'20px', textAlign:'center' }}
                                                onClick={() => handleAbsentClick(currentAttendanceSummary.classId)}
                                            >
                                                {currentAttendanceSummary.absentStudents}
                                            </TableCell>


                                        </TableRow>


                                    );
                                })}

                            </TableBody>
                        </Table>
                        </TableContainer>
                        {showAbsentListClassId && absentStudentList.length > 0 && (
                            <Box
                                mt={3}
                                display="flex"
                                justifyContent="center"
                            >
                                <Box
                                    p={2}
                                    width="60%"
                                    bgcolor="#fff0f0"
                                    border="1px solid #ffcccc"
                                    borderRadius={8}
                                    boxShadow={2}
                                    textAlign="left"
                                >
                                    <strong style={{ color: "#cc0000", fontSize: "18px" }}>
                                        Absent Students:
                                    </strong>
                                    <ul style={{ paddingLeft: "20px", color: "#cc0000", marginTop: "10px" }}>
                                        {absentStudentList.map((student) => (
                                            <li key={student.studentId}>{student.studentName}</li>
                                        ))}
                                    </ul>
                                </Box>
                            </Box>
                        )}

                        <TablePagination
                            component="div"
                            rowsPerPageOptions={[10, 25, 50]}
                            count={reportList.length}
                            page={0}
                            rowsPerPage={10}
                            onPageChange={() => { }}
                        />
                    </Widget>
                </Grid>
            </Grid>
        </>
    );
}


